import React from "react";
import "../styles/team.css";

export const team = ({ data }) => {
  return (
    <>
      <section className="teamLandingPage">
        <h1>Meet the Team</h1>
      </section>
      <section className="teamIntro">
        <div className="teamWrap">
          {data.map(({ id, img, name, role }) => (
            <li key={id}>
              <div className="teamImg">
                <img src={img} alt="team Member" />
              </div>
              <div className="teamOverlay">
                <h3>{name}</h3>
                <p>{role}</p>
              </div>
            </li>
          ))}
        </div>
      </section>
      <section className="quote">
        <h1 className="quoteStart">‘‘</h1>
        <p>
          Thank you for being fantastic team members. Global Capability Director
        </p>
        <h1 className="quoteEnd">’’</h1>
      </section>
    </>
  );
};

export default team;
